import { useLanguage } from '../context/LanguageContext';
import { SpotlightCard } from '../reactbits';

export default function TrustPillars() {
  const { t } = useLanguage();
  const pillars = [
    {
      num: '01',
      title: t('trust.1.title'),
      body: 'Advice should answer to you - not to a commission. Built on the SEBI Registered Investment Adviser route: advice legally bound to your interest, not to what pays the seller most.',
    },
    {
      num: '02',
      title: t('trust.2.title'),
      body: "Every recommendation comes with its reasoning. If you can't understand why, we haven't done our job.",
    },
    {
      num: '03',
      title: t('trust.3.title'),
      body: 'Your goals, your horizon, your comfort with risk. Guidance shaped around your life - not a generic model portfolio.',
    },
  ];

  return (
    <div className="grid grid-3">
      {pillars.map((p) => (
        <SpotlightCard as="article" className="pillar" key={p.num}>
          <div className="pillar__num">{p.num}</div>
          <h3 className="pillar__title">{p.title}</h3>
          <p>{p.body}</p>
        </SpotlightCard>
      ))}
    </div>
  );
}
